import { Attributes, DateUtils, Misc, Rules, Validation, ValueObject } from '@singularsystems/neo-core';
import { ReportType } from '../ReportType';

export default class LetterAuthorisationBatchCriteria extends ValueObject {

    constructor() {
        super();
        this.makeObservable();
    }

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public startDate: Date | null = DateUtils.add(DateUtils.today(), { days: -7 });

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public endDate: Date | null = DateUtils.add(DateUtils.today(), { days: 30 });

    @Attributes.Nullable()
    public reportType: ReportType | null = null;

    @Attributes.Nullable()
    public entityId: number | null = null;

    @Attributes.Nullable()
    public investorReferralTypeId: number | null = null;

    @Attributes.Nullable()
    public investorId: number | null = null;

    public boolFilter: boolean | null = null;

    public description: string | null = null;

    // Client only properties / methods

    @Attributes.NoTracking()
    public forNewBatch: boolean = false;

    @Attributes.NoTracking()
    public investor: string = "";

    public get hasDifferentDates() {
        return this.startDate?.getTime() !== this.endDate?.getTime();
    }

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);

        rules.failWhen(c => c.forNewBatch && c.reportType === ReportType.BankTransferFormCapital && !c.investorId && !c.investorReferralTypeId,
            "Investor or Investor Type is required.").onProperties(c => c.reportType);
    }

    public toString(): string {
        return "Letter Authorisation Batch Criteria";
    }
}